function match(item, key, value) {
  if (value === undefined) {
    return true;
  }
  if (value.min && value.max) {
    // supplied value is a range
    return item.filter[key] <= value.max && item.filter[key] >= value.min;
  }

  if (item.logic[key] !== undefined) {
    return item.logic[key] === value;
  }

  return item.filter[key] === value;
}

export function filter(array, ...filters) {
  if (!Array.isArray(filters) || filters.length === 0) {
    return array.slice();
  }

  return array.filter(item => {
    return filters.some(filter => {
      const entries = Object.entries(filter);

      return entries.every(([key, value]) => match(item, key, value));
    });
  });
}
